module.exports = __webpack_public_path__ + "img/shipo-sales-plan-icon-trash.b6d9e218.svg";